// User API services for React 19 with TypeScript
import type { AxiosInstance, AxiosResponse } from 'axios';
import type { ErrorHandlerOptions } from './error_handler';

// Type definitions
type ErrorHandler = <T = any>(
  _request: Promise<AxiosResponse<T>>,
  _options?: ErrorHandlerOptions
) => Promise<AxiosResponse<T> | string>;

// Factory function to create user services
export const userServices = (
  _env: string,
  api: AxiosInstance,
  errorHandler: ErrorHandler
) => ({
  requestNewPassword: async (
    email: string
  ): Promise<AxiosResponse | string> => {
    const url = `/api/v1/users/requestNewPass`;
    return errorHandler(api.post(url, email));
  },
});
